import Amazon from "./amazon.png?url";
import Apc from "./apc.png?url";
import Asendia from "./asendia.png?url";
import AustraliaPost from "./australia-post.png?url";
import CanadaPost from "./canada-post.png?url";
import Canpar from "./canpar.png?url";
import ChitChats from "./chitchats.png?url";
import Dhl from "./dhl.png?url";
import EPostGlobal from "./epostglobal.png?url";
import EtaExpress from "./eta-express.png?url";
import Fedex from "./fedex.png?url";
import FirstMile from "./firstmile.png?url";
import FleetOptics from "./fleet-optics.png?url";
import GlobalE from "./globale.png?url";
import Gls from "./gls.png?url";
import IcsCourier from "./ics-courier.png?url";
import Intelcom from "./intelcom.png?url";
import LandmarkGlobal from "./landmark-global.png?url";
import Ups from "./official-ups.png?url";
import Omniparcel from "./omniparcel.png?url";
import OnTrac from "./ontrac.png?url";
import PassportGlobal from "./passport-global.png?url";
import PostNL from "./postnl.png?url";
import Purolator from "./purolator.png?url";
import RoyalMail from "./royalmail.png?url";
import Sendcloud from "./sendcloud.png?url";
import Sendle from "./sendle.png?url";
import SpeeDee from "./spee-dee.png?url";
import StallionExpress from "./stallion.png?url";
import UniUni from "./uniuni.png?url";
import Usps from "./usps.png?url";
import Veho from "./veho.png?url";
import WhizDelivery from "./whiz-delivery.png?url";

export function getCarrierLogoUrl(carrier: string): string {
  if (!carrier) {
    return "";
  }
  // TODO (jaden): use svg
  if (carrier.toLowerCase().includes("ups")) {
    return Ups;
  } else if (carrier.toLowerCase().includes("fedex")) {
    return Fedex;
  } else if (carrier.toLowerCase().includes("usps")) {
    return Usps;
  } else if (carrier.toLowerCase().includes("dhl")) {
    return Dhl;
  } else if (carrier.toLowerCase().includes("sendcloud")) {
    return Sendcloud;
  } else if (carrier.toLowerCase().includes("sendle")) {
    return Sendle;
  } else if (carrier.toLowerCase().includes("amazon")) {
    return Amazon;
  } else if (carrier.toLowerCase().includes("veho")) {
    return Veho;
  } else if (carrier.toLowerCase().includes("firstmile")) {
    return FirstMile;
  } else if (carrier.toLowerCase().includes("australia")) {
    return AustraliaPost;
  } else if (
    carrier.toLowerCase().includes("canada post") ||
    carrier.toLowerCase().includes("canadapost")
  ) {
    return CanadaPost;
  } else if (carrier.toLowerCase().includes("royal")) {
    return RoyalMail;
  } else if (carrier.toLowerCase().includes("apc")) {
    return Apc;
  } else if (carrier.toLowerCase().includes("omni")) {
    return Omniparcel;
  } else if (
    carrier.toLowerCase().includes("gls") ||
    carrier.toLowerCase().includes("gso")
  ) {
    return Gls;
  } else if (carrier.toLowerCase().includes("asendia")) {
    return Asendia;
  } else if (carrier.toLowerCase().includes("spee")) {
    return SpeeDee;
  } else if (carrier.toLowerCase().includes("passport")) {
    return PassportGlobal;
  } else if (carrier.toLowerCase().includes("landmark")) {
    return LandmarkGlobal;
  } else if (carrier.toLowerCase().includes("eta express")) {
    return EtaExpress;
  } else if (carrier.toLowerCase().includes("epost")) {
    return EPostGlobal;
  } else if (carrier.toLowerCase().includes("ontrac")) {
    return OnTrac;
  } else if (carrier.toLowerCase().includes("globale")) {
    return GlobalE;
  } else if (carrier.toLowerCase().includes("purolator")) {
    return Purolator;
  } else if (carrier.toLowerCase().includes("canpar")) {
    return Canpar;
  } else if (carrier.toLowerCase().includes("uniuni")) {
    return UniUni;
  } else if (carrier.toLowerCase().includes("stallion")) {
    return StallionExpress;
  } else if (carrier.toLowerCase().includes("chitchats")) {
    return ChitChats;
  } else if (carrier.toLowerCase().includes("postnl")) {
    return PostNL;
  } else if (carrier.toLowerCase().includes("intelcom")) {
    return Intelcom;
  } else if (carrier.toLowerCase().includes("fleet")) {
    return FleetOptics;
  } else if (
    carrier.toLowerCase() === "ics" ||
    carrier.toLowerCase().includes("ics courier")
  ) {
    return IcsCourier;
  } else if (carrier.toLowerCase().includes("whiz")) {
    return WhizDelivery;
  }
  return "";
}
